import { ForgotToScanScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ForgotToScanScreen />;
}
